import { useLoader } from "@react-three/fiber";
import * as THREE from "three";

const SpellIndicator = (props: any) => {
    const texture = useLoader(THREE.TextureLoader, "/images/textures/spellIndicator.png");

    return (
      <mesh {...props} rotation={[ Math.PI / 2, 0, 0 ]}> 
        <planeGeometry args={[0.5, 4]} />
        <meshStandardMaterial 
          map={texture} 
          transparent 
          side={THREE.DoubleSide} 
          emissive={new THREE.Color(0x0042ff)}
          emissiveIntensity={1}
          metalness={0}
          roughness={0}
        />
      </mesh>
    );
};

export default SpellIndicator;
